import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./index.module.scss";
import ButtonC from "../../../button";
import DropdownC from "../../../dropdown";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";

const callingStatusOptions = [
  { label: "Interested", value: "interested" },
  { label: "Not Interested", value: "not interested" },
  {
    label: "Further Information Requested",
    value: "further information requested"
  },
  {
    label: "Wrong Contact Information",
    value: "Wrong Contact Information"
  },
  { label: "Callback Requested", value: "callback requested" },
  { label: "Voicemail Left", value: "voice mail left" },
  { label: "No Answer", value: "no answer" },
  { label: "Unavailable", value: "unavailable" },
  { label: "No Longer Investing", value: "no longer investing" },
  { label: "Do Not Contact", value: "do not contact" },
  { label: "Blacklisted", value: "blacklisted" },
  { label: "Wholesaler", value: "wholesaler" }
];

const lastCallOptions = [
  { label: "Today", value: "today" },
  { label: "Not Interested", value: "notInterested" },
  { label: "Last 3 days", value: "last3Days" },
  { label: "Last 7 days", value: "last7Days" },
  { label: "More than 7 days ago", value: "moreThan7Days" }
];

const callAttemptsOptions = [
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "5+", value: "5+" }
];

export default function FilterModelBody({
  onClose,
  popRef,
  setShowModel
}: any) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [callingStatus, setCallingStatus] = useState<any>(null);
  const [investorType, setInvestorType] = useState<{
    myVault: boolean;
    myCheckout: boolean;
  }>({ myVault: false, myCheckout: false });
  const [doNotDisturb, setDoNotDisturb] = useState(false);
  const [lastCall, setLastCall] = useState<any>(null);
  const [callAttempts, setCallAttempts] = useState<any>(null);
  const [hasCallback, setHasCallback] = useState(false);

  useEffect(() => {
    const cs = searchParams.get("callingStatus");
    const dnd = searchParams.get("doNotDisturb");
    const lc = searchParams.get("lastCall");
    const ca = searchParams.get("callAttempts");
    const hc = searchParams.get("hasCallback");
    const mv = searchParams.get("myVault") === "true" ? true : false;
    const mc = searchParams.get("myCheckout") === "true" ? true : false;

    setInvestorType({ myVault: mv, myCheckout: mc });
    setCallingStatus(cs);
    setDoNotDisturb(dnd === "true");
    setLastCall(lc);
    setCallAttempts(ca);
    setHasCallback(hc === "true");
  }, [searchParams]);

  const handleApply = () => {
    const params = new URLSearchParams(searchParams);

    if (callingStatus) params.set("callingStatus", callingStatus);
    else params.delete("callingStatus");

    if (doNotDisturb) params.set("doNotDisturb", "true");
    else params.delete("doNotDisturb");

    if (lastCall) params.set("lastCall", lastCall);
    else params.delete("lastCall");

    if (callAttempts) params.set("callAttempts", callAttempts);
    else params.delete("callAttempts");

    if (hasCallback) params.set("hasCallback", "true");
    else params.delete("hasCallback");

    if (investorType?.myVault)
      params.set("myVault", investorType?.myVault?.toString());
    else params.delete("myVault");

    if (investorType?.myCheckout)
      params.set("myCheckout", investorType?.myCheckout?.toString());
    else params.delete("myCheckout");

    setSearchParams(params);

    if (typeof onClose === "function") {
      onClose();
    } else if (popRef?.current?.hide) {
      popRef.current.hide();
    } else if (typeof setShowModel === "function") {
      setShowModel(false);
    }
  };

  return (
    <div className={styles.filterModelBody}>
      <div className={styles.filterSection}>
        <label className={styles.label}>Calling Status</label>
        <DropdownC
          showClear={true}
          value={callingStatus}
          onChange={(e: any) => setCallingStatus(e.value)}
          options={callingStatusOptions}
          optionLabel="label"
          placeholder="Select status"
          panelClassName={styles.dropdownList}
          className={styles.dropdownBox}
        />
        <label className={styles.label}>Investor Type</label>
        <div className={styles.checkboxRow}>
          <Checkbox
            type="checkbox"
            checked={investorType.myVault}
            className={styles.checkBox}
            onChange={(e) =>
              setInvestorType((v: any) => ({ ...v, myVault: e.target.checked }))
            }
          />
          <label className={styles.checkboxLabel}>My Vault</label>
          <Checkbox
            type="checkbox"
            checked={investorType.myCheckout}
            className={styles.checkBox}
            onChange={(e) =>
              setInvestorType((v: any) => ({
                ...v,
                myCheckout: e.target.checked
              }))
            }
          />
          <label className={styles.checkboxLabel}>Checked Out</label>
        </div>
        <div className={styles.switchRow}>
          <label className={styles.label}>Do Not Disturb</label>
          <InputSwitch
            checked={doNotDisturb}
            className={styles.inputSwitch}
            onChange={(e: any) => setDoNotDisturb(e.value)}
          />
        </div>
        <label className={styles.label}>Last Call Attempted</label>
        <DropdownC
          panelClassName={styles.dropdownList}
          showClear={true}
          onChange={(e: any) => setLastCall(e.value)}
          options={lastCallOptions}
          optionLabel="label"
          placeholder="Please select"
          value={lastCall}
          className={styles.dropdownBox}
        />
        <label className={styles.label}>No. of Call Attempts</label>
        <DropdownC
          value={callAttempts}
          showClear={true}
          onChange={(e: any) => setCallAttempts(e.value)}
          options={callAttemptsOptions}
          optionLabel="label"
          placeholder="Please select"
          panelClassName={styles.dropdownList}
          className={styles.dropdownBox}
        />
        <div className={styles.switchRow}>
          <label className={styles.label}>Has Callback Scheduled</label>
          <InputSwitch
            checked={hasCallback}
            className={styles.inputSwitch}
            onChange={(e: any) => setHasCallback(e.value)}
          />
        </div>
      </div>
      <ButtonC
        disabled={false}
        type="button"
        label="Apply"
        size="large"
        className={styles.applyBtn}
        onClick={handleApply}
      />
    </div>
  );
}
